import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTcsmEpiProps, setTerminationSettings } from '../../../../../global/ducks/epi-api';
import { TcsmEpiApiState, TcsmStates } from '../../../../../root/tcsm-model';

export function useTerminationSettings(terminationSettingsId: string) {
	const dispatch = useDispatch();
	const epiApiState = useSelector<TcsmStates, TcsmEpiApiState>(state => state.epiProps);
	const language = useSelector<TcsmStates, string>(state => state.globalization.currentlanguage);
	const guid = useSelector<TcsmStates, string>(state => state.authenticatedState?.clientGuid);

	useEffect(() => {
		if (!epiApiState?.terminationSettingsState?.contentLoaded) {
			dispatch(getTcsmEpiProps(dispatch, terminationSettingsId, { guid }, language, false, setTerminationSettings));
		}
	}, []);

	return epiApiState?.terminationSettingsState?.contentLoaded;
}